export default "__VITE_ASSET__CZy95v_c__"